import { render, staticRenderFns } from "./AdminHistoryModal.vue?vue&type=template&id=24efb38d&"
import script from "./AdminHistoryModal.vue?vue&type=script&lang=js&"
export * from "./AdminHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports